import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import CircularProgress from "@mui/material/CircularProgress";

import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { useDispatch, useSelector } from "react-redux";

import { login } from "../../actions/userActions";
import Message from "../../components/Message";
import Navbar from "../../components/navbars/Navbar";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="#">
        RAZI TECHNOLOGY
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const theme = createTheme();

export default function LoginAdmin({ location, history, props }) {
  const dispatch = useDispatch();
  // variable locale
  const [passError, setpassError] = useState(false);
  const [mailError, setmailError] = useState(false);
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  // get user info from state
  const { error, loading, userInfo } = useSelector((state) => state.userLogin);
  let navigate = useNavigate();

  useEffect(() => {
    if (userInfo) {
      navigate("/patient");
    }
  }, [history, userInfo, navigate]);

  const loginHundler = (e) => {
    setmailError(false);

    setpassError(false);

    e.preventDefault();
    if (email === "" || password === "") {
      if (email === "") {
        setmailError(true);
      }
      if (password === "") {
        setpassError(true);
      }
    } else {
      dispatch(login(email, password));
    }
  };

  return (
    <Navbar>
      <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 30,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {error && <Message variant="error">{error}</Message>}
            <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Espace Patient
            </Typography>
            <Box
              component="form"
              onSubmit={loginHundler}
              noValidate
              sx={{ mt: 1 }}
            >
              {loading ? (
                <div className="d-flex justify-content-center">
                  <CircularProgress color="inherit" />
                </div>
              ) : (
                <>
                  <TextField
                    margin="normal"
                    error={mailError}
                    required
                    fullWidth
                    id="email"
                    label="Adresse e-mail"
                    name="email"
                    autoComplete="email"
                    helperText={mailError && "ce champ est vide !"}
                    autoFocus
                    onChange={(e) => setemail(e.target.value)}
                  />
                  <TextField
                    margin="normal"
                    error={passError}
                    required
                    fullWidth
                    name="password"
                    label="Mot de passe"
                    helperText={passError && "ce champ est vide !"}
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    onChange={(e) => setpassword(e.target.value)}
                  />
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                  >
                    Se connecter
                  </Button>
                </>
              )}
            </Box>
          </Box>
          <Copyright sx={{ mt: 8, mb: 4 }} />
        </Container>
      </ThemeProvider>
    </Navbar>
  );
}
